import React, { createElement } from "react";
import { connect } from "react-redux";
import ReactMarkdown from "react-markdown";
import ReactPlayer from "react-player";
import { Style } from "radium";
import { informal } from "../utilities/date";
import { Link } from "react-router-dom";
import { cropMaskStyles } from "../components/ArticlePost";
import Radium from "radium";
import { serifFontFamily } from "../utilities/styles";
// const fontFamily = name => {
//   // switch(name.toLowerCase()) {
//     // case 'casual serif': {
//     //   return "'Arvo', 'Georgia', serif";
//     // }
//     // case 'formal serif': {
//     //   return "'Merriweather', 'Georgia', serif";
//     // }
//     // default: {
//       // return "'Nunito', helvetica, arial, sans-serif";
//     // }
//   }
// }
const getCoreProps = (props) => {
  return props["data-sourcepos"] ? { "data-sourcepos": props["data-sourcepos"] } : {};
};

const Heading = (props) => {
  return createElement(`h${props.level}`, getCoreProps(props), props.children);
};

const CustomHeading = (props) => {
  if (props.level < 6) {
    return Heading(props);
  }
  return createElement(`span`, getCoreProps(props), props.children);
};

const Post = ({ match, history, posts = [] }) => {
  const post = posts.find((p) => p.id === match.params.id);

  if (!post) {
    return <span></span>;
  } else {
    let template = {
      backgroundColor: "white",
      linkColor: "magenta",
    };

    if (post.template) {
      template = { ...template, ...post.template.fields };
    }

    return (
      <div
        className="pb2"
        style={{
          ...(template.backgroundPattern
            ? {
                background: `url("${template.backgroundPattern.fields.file.url}") repeat`,
              }
            : { backgroundColor: template.backgroundColor }),
          paddingTop: "3em",
        }}
      >
        {post && (
          <div>
            <div className="center">
              {!post.leadMedia && post.leadImage && (
                <div style={cropMaskStyles}>
                  <img src={post.leadImage.fields.file.url} />
                </div>
              )}
              {post.leadMedia && <ReactPlayer url={post.leadMedia} className="mx-auto" />}
            </div>
            <div
              className="post p3 rounded"
              style={{ backgroundColor: template.contentBackgroundColor }}
            >
              <section className="mb3">
                {post.datePosted && (
                  <p style={{ color: template.bodyColor }} className="thin mb0">
                    {informal(new Date(post.datePosted))}
                  </p>
                )}
                {(post.humanlyIssue || post.type) && (
                  <div
                    style={{ fontWeight: "bold" }}
                    className="border-top border-bottom border-gray py1 mt1"
                  >
                    {post.humanlyIssue && (
                      <img src="/eye-icon.svg" style={{ height: "1em" }} />
                    )}{" "}
                    {post.humanlyIssue && (
                      <span>
                        Humanly Issue{" "}
                        <span className="bold">
                          {post.humanlyIssue.fields.issueNumber}
                        </span>
                      </span>
                    )}
                    {!post.humanlyIssue && post.type && (
                      <span>
                        <span className="bold">{post.type}</span>
                      </span>
                    )}
                  </div>
                )}
                <h1
                  style={{ color: template.titleColor, fontFamily: serifFontFamily }}
                  className="my0"
                >
                  {post.title}
                </h1>
                <h2
                  style={{ color: template.subtitleColor, fontWeight: 100 }}
                  className="mt0"
                >
                  {post.leadText ? post.leadText : post.subtitle}
                </h2>
                {post.author && (
                  <p className="italic" style={{ color: template.bodyColor }}>
                    By {post.author}
                  </p>
                )}
              </section>

              <div className="post__body">
                <Style
                  scopeSelector=".post__body"
                  rules={{
                    "p,em,bold": {
                      color: template.bodyColor,
                      fontSize: ".95em",
                      lineHeight: "1.75em",
                      fontWeight: "100",
                    },
                    p: {
                      marginTop: ".5em",
                    },
                    img: {
                      display: "block",
                      marginRight: "auto",
                      marginLeft: "auto",
                    },
                    "h1,h2,h3,h4,h5": {
                      color: template.headerColor,
                      marginBottom: ".25em",
                      fontFamily: serifFontFamily,
                    },
                    h3: {
                      fontSize: "1.1em",
                    },
                    code: {
                      fontFamily: "'Nunito', Helvetica, sans-serif",
                      fontSize: "12px",
                      margin: 0,
                      fontWeight: "100",
                      fontStyle: "italic",
                      textDecoration: "none",
                    },
                    a: {
                      color: template.linkColor,
                    },
                    blockquote: {
                      fontFamily: serifFontFamily,
                      margin: "2em 0em",
                      backgroundColor: template.calloutBackground,
                      color: template.calloutColor,
                      padding: "1.5em",
                    },
                    "blockquote p": {
                      margin: "0",
                    },
                  }}
                />
                <ReactMarkdown
                  source={post.body}
                  escapeHtml={false}
                  renderers={{ heading: CustomHeading }}
                />
                {post.video && <ReactPlayer url={post.video} width="100%" />}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    posts: state.posts,
  };
};

export default connect(mapStateToProps)(Radium(Post));



// WEBPACK FOOTER //
// ./src/pages/Post.js